const loadingLabel = "Lade";
const deAT = {
  loadingLabel
};
export {
  deAT as default,
  loadingLabel
};
